import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { db } from "./firebase.js";
import { collection, getDocs } from "firebase/firestore";
import './Eventi.css';

export default function Eventi() {
  const navigate = useNavigate();
  const [nuoviEventi, setNuoviEventi] = useState([]);
  const [loading, setLoading] = useState(true);

  // Eventi statici già presenti
  const eventiStatici = [
    { nome: "Welcome Matricole", path: "/welcome-matricole" },
    { nome: "Winter Week", path: "/winter-week" },
    { nome: "Torneo di Pallacanestro", path: "/torneo-pallacanestro" }
  ];

  // Fetch eventi dinamici dal DB
  useEffect(() => {
    const fetchEventi = async () => {
      setLoading(true);
      try {
        const snapshot = await getDocs(collection(db, "eventi"));
        const data = snapshot.docs.map(doc => ({ id: doc.id, ...doc.data() }));
        setNuoviEventi(data);
      } catch (err) {
        console.error("Errore fetching eventi:", err);
      } finally {
        setLoading(false);
      }
    };

    fetchEventi();
  }, []);

  // Gestione click su evento dinamico
  const handleClickEvento = (evento) => {
    // Passa tutti i dati dell'evento allo stato della route
    navigate(evento.path, { state: { evento } });
  };

  return (
    <div className="eventi-container">
      <div className="eventi-content">
        <h1 className="eventi-title">Eventi CUSAS</h1>
        <p className="eventi-subtitle">Scopri i nostri eventi più importanti!</p>

        <div className="button-group">
          {/* Eventi statici */}
          {eventiStatici.map((e, idx) => (
            <button
              key={`static-${idx}`}
              className="eventi-button"
              onClick={() => navigate(e.path)}
            >
              {e.nome}
            </button>
          ))}

          {/* Eventi dinamici */}
          {loading ? (
            <p>Caricamento nuovi eventi...</p>
          ) : (
            nuoviEventi.map(e => (
              <button
                key={e.id}
                className="eventi-button"
                onClick={() => handleClickEvento(e)}
              >
                {e.nome}
              </button>
            ))
          )}
        </div>
      </div>
    </div>
  );
}
